import { useEffect, useState } from 'react';
import { Form } from 'antd';
import VoucherService from 'services/voucher';
import { useApp } from 'contexts/app';

const service = new VoucherService();

const defaultVoucher = {
  id: null,
  code: '',
  description: '',
  type: 'fixed',
  value: 10000,
  usage_limit: 1,
};

const useVoucherModal = ({ open, onClose, id, onSaved }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [voucher, setVoucher] = useState({});
  const { showLoading, showNotify } = useApp();
  const [form] = Form.useForm();

  const loadData = async () => {
    if (!id) {
      setVoucher(defaultVoucher);
      return;
    }

    const currentVoucher = await service.get(id);
    setVoucher(currentVoucher);
  };

  useEffect(() => {
    setIsModalOpen(open);
    loadData();
  }, [open, id]);

  useEffect(() => {
    form.setFieldsValue(voucher);
  }, [voucher, form]);

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    onClose();
  };

  const onFinish = async (values) => {
    showLoading(true);
    try {
      const savedVoucher = await service.create(values);
      setVoucher(savedVoucher);
      showNotify(`Voucher ${savedVoucher.code} đã được tạo`);
      if (onSaved) {
        onSaved(savedVoucher);
      }
    } catch (error) {
      console.log('error', error);
    }
    onClose();
    showLoading(false);
  };

  const copyVoucherCode = async (text) => {
    await window.navigator.clipboard.writeText(text);
    showNotify(`Đã copy ${text}`);
  };

  return {
    form,
    isModalOpen,
    voucher,
    handleOk,
    handleCancel,
    onFinish,
    copyVoucherCode,
  };
};

export default useVoucherModal;